import { Image as BuilderImage } from "@builder.io/react";
import { useEffect, useRef } from "react";

export const PriorityBuilderImage = ({ fetchPriority = "high", ...props }) => {
    const wrapperRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const img = wrapperRef.current?.querySelector("img");
        if (img) {
            img.setAttribute("fetchpriority", fetchPriority);
        }
    }, [fetchPriority]);

    return (
        <div ref={wrapperRef} style={{ display: "contents" }}>
            {/* @ts-ignore */}
            <BuilderImage {...props} />
        </div>
    );
};
